import React from "react";
import Icon from "../Icon";
import styled from "styled-components";
import MediaQuery from "../../../components/MediaQuery";

// Styled components
const HowItWorksCard = styled.div`
  background: #fff;
  box-shadow: 0 10px 30px rgba(44, 80, 89, 0.09);
  border-radius: 5px;
  padding: 30px;
  letter-spacing: 0.5px;
  max-width: 389px;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  margin-bottom: 30px;

  ${MediaQuery.desktop`
    width: 24%;
  `};
`;

const SubHeader = styled.h6`
  color: orange;
  font-size: 1em;
`;

const Details = styled.div`
  line-height: 1.8;
`;

const Img = styled.img`
  width: 144px;
`;

// import "./styles.css";

const Card = ({ iconClass, subHeader, details, src }) => {
  return (
    <HowItWorksCard>
      {iconClass && <Icon iconClass={iconClass} />}
      {src && <Img src={src} alt={subHeader} />}
      <SubHeader>{subHeader}</SubHeader>
      <Details>{details}</Details>
    </HowItWorksCard>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/Card/index.js